interface PromptSuggestionsProps {
  label: string
  append: (message: { role: "user"; content: string }) => void
  suggestions: string[]
}

export function PromptSuggestions({
  label,
  append,
  suggestions,
}: PromptSuggestionsProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-center text-2xl font-bold">{label}</h2>
      <div className="flex gap-6 text-sm">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => append({ role: "user", content: suggestion })}
            className="h-max flex-1 rounded-xl border bg-background p-4 hover:bg-muted"
          >
            <p>{suggestion}</p>
          </button>
        ))}
      </div>
    </div>
  )
}

interface InlinePromptButtonsProps {
  label?: string
  onSelectPrompt: (prompt: string) => void
  suggestions: string[]
}

export function InlinePromptButtons({
  label,
  onSelectPrompt,
  suggestions,
}: InlinePromptButtonsProps) {
  return (
    <div className="space-y-2">
      {label && <p className="text-sm text-foreground whitespace-pre-line">{label}</p>}
      <div className="flex flex-row gap-2 flex-wrap">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => onSelectPrompt(suggestion)}
            className="rounded-[25px] bg-white px-5 py-3 text-sm text-[#8F8F8F] font-medium shadow-[0_0_11px_0_rgba(0,0,0,0.10)] transition-all hover:bg-gray-50 hover:text-foreground"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  )
}
